import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("token");

    navigate("/admin-login");
  }, [navigate]);

  return (
    <div className="text-center mt-5">
      <h4>Logging out...</h4>
    </div>
  );
};

export default Logout;
